import styled from "@emotion/styled";
import { MODAL_BACKGROUND } from "constants/z-index";
const Z_INDEX = MODAL_BACKGROUND + 1;
export const StylesGraphiqlComponent = styled.div`
  .CodeMirror-info,
  .CodeMirror-lint-tooltip {
    z-index: ${Z_INDEX};
  }

  .CodeMirror * {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  reach-portal {
    [data-reach-tooltip],
    [data-reach-popover],
    [data-reach-dialog-overlay] {
      z-index: ${Z_INDEX};
    }
  }

  .graphiql-container,
  .CodeMirror-info,
  .CodeMirror-lint-tooltip,
  reach-portal {
    /* Colors */
    --color-primary: 211, 100%, 46%;
    --color-secondary: 242, 51%, 61%;
    --color-tertiary: 188, 100%, 36%;
    --color-info: 208, 100%, 46%;
    --color-success: 158, 60%, 42%;
    --color-warning: 36, 100%, 41%;
    --color-error: 13, 93%, 58%;
    --color-neutral: 219, 28%, 32%;
    --color-base: 219, 28%, 100%;

    /* Color alpha values */
    --alpha-secondary: 0.76;
    --alpha-tertiary: 0.5;
    --alpha-background-heavy: 0.15;
    --alpha-background-medium: 0.1;
    --alpha-background-light: 0.07;

    /* Font */
    --font-family: var(--font-family);
    --font-family-mono: "Fira Code", monospace;
    --font-size-hint: var(--font-size-subtext);
    --font-size-inline-code: calc(13rem / 16);
    --font-size-body: var(--font-size-general-label);
    --font-size-h4: var(--font-size-h4);
    --font-size-h3: var(--font-size-h3);
    --font-size-h2: var(--font-size-h2);
    --font-weight-regular: 400;
    --font-weight-medium: 500;
    --line-height: 1.5;

    /* Spacing */
    --px-2: 2px;
    --px-4: 4px;
    --px-6: 6px;
    --px-8: 8px;
    --px-10: 10px;
    --px-12: 12px;
    --px-16: 16px;
    --px-20: 20px;
    --px-24: 16px;

    /* Border radius */
    --border-radius-2: 2px;
    --border-radius-4: 4px;
    --border-radius-8: 8px;
    --border-radius-12: 12px;

    /* Popover styles (tooltip, dialog, etc) */
    --popover-box-shadow: 0px 6px 20px rgba(59, 76, 106, 0.13), 0px 1.34018px 4.46726px rgba(59, 76, 106, 0.0774939),
      0px 0.399006px 1.33002px rgba(59, 76, 106, 0.0525061);
    --popover-border: none;

    /* Layout */
    --sidebar-width: 60px;
    --toolbar-width: 40px;
    --session-header-height: 51px;
  }

  height: 100%;

  * {
    box-sizing: unset;
  }

  .disclaimer-text {
    padding: var(--px-8) var(--px-8) 0 0;
    text-align: end;
  }
`;
